module.exports = __webpack_public_path__ + "img/5.d8deaff2.jpg";